import { CaretRightOutlined, RightOutlined, EditOutlined, FilterOutlined, UserOutlined, PrinterOutlined, QuestionCircleOutlined, DeleteOutlined, ContactsOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  Select,
  Radio,
  Checkbox,
  Space,
  Spin,
  Table,
  Drawer,
  Popover,
  Avatar,
  Popconfirm
} from "antd";
import { formatCountdown } from "antd/lib/statistic/utils";

import React from 'react';


import { useState } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';


import memberService from "../../api/member.service";
import CustomTableSearch from "../common/CustomTableSearch";
import { ALL_MEMBER_PROFILE_URL, CONTACT_INFO_PRINT_URL, MEDIA_URL, MEMBER_MEDIA_URL } from "../../utility/URL";
import commonUtility from "../../utility/Utils";
import { SUCCESS_STATUS } from "../../utility/Constants";
const { Option } = Select;




const RegistrationList = () => {

  const [memberList, setMemberList] = useState([]);
  const [filteredSearchList, setFilteredSearchList] = useState([]);

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);

  const [filterFormData] = Form.useForm();
  const [isSuccessRefreshList, setIsSuccessRefreshList] = useState(false);

  const cancel = (e) => {
    console.log("No clik", e);
    //message.error('Click on No');
  };


  const confirmDelete = (member_id) => {

    const data = { formdata: { id: member_id } };

    memberService.deleteMember(data).then((res) => {

      setIsSuccessRefreshList(false)
      if (res.data.response_status == SUCCESS_STATUS) {
        setIsSuccessRefreshList(true)
        // message.success(res.response_msg);
        commonUtility.openNotificationWithType("success", "bottomRight", "Success", res.data.response_msg);
      }
      else {
        //message.error(res.response_msg);
        commonUtility.openNotificationWithType("error", "bottomRight", "Error", res.data.response_msg);
      }

    });





  };


  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      render: (text, record, index) => (page - 1) * 10 + ++index,
      width: '5%',
    },
    {
      title: 'Action',
      key: 'action',
      render: (selectedObj, record) => (
        <>
          <div style={{
            display: "flex", alignItems: "baseline", gap: "8px"
          }}>
            <Link to={`/registration/${selectedObj.member_id}`} >
              <Button htmlType="button" type="ghost" size="small" shape="round" className="custombutton-type1"><EditOutlined /></Button>
            </Link>

            <Button htmlType="button" type="ghost" size="small" shape="round" className="custombutton-type1" style={{
              marginTop: '5px',
              background: '#ddfbb9',
              border: '1px solid #abca87',
              color: '#44661c',
              fontWeight: 'bold',
            }}
              onClick={() => commonUtility.openInNewTab(`${ALL_MEMBER_PROFILE_URL}/${selectedObj.member_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`)}
            ><PrinterOutlined /></Button>

            <Button htmlType="button" type="ghost" size="small" shape="round" className="custombutton-type1" style={{
              marginTop: '5px',
              background: '#ddfbb9',
              border: '1px solid #abca87',
              color: '#44661c',
              fontWeight: 'bold',
            }}
              onClick={() => commonUtility.openInNewTab(`${CONTACT_INFO_PRINT_URL}/${selectedObj.member_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`)}
            ><ContactsOutlined /></Button>

            {


              commonUtility.sanitizeObject(record.short_code_text) == "" ? <>


                <Popconfirm
                  title="Data cann't be undone if deleted. Do you want to delete? "
                  icon={
                    <QuestionCircleOutlined
                      style={{
                        color: 'red',
                      }}
                    />
                  }
                  onConfirm={() => confirmDelete(selectedObj.member_id)}
                  onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button htmlType="button" type="danger" size="small" shape="round" ><DeleteOutlined /></Button>
                </Popconfirm>


              </> : <></>
            }



          </div>

        </>

      ),
    },
    {
      title: 'Programme',
      dataIndex: 'short_code_text',
      key: 'short_code_text',
      sorter: (a, b) => (a.short_code_text ?? '').localeCompare(b.short_code_text ?? ''),
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {commonUtility.sanitizeObject(record.short_code_text) != "" ? <>
            <span>{`${record.short_code_text} ${commonUtility.sanitizeObject(record?.programme_group) != "" ? record.programme_group : ""}`}</span>
          </> : <></>}
        </Space>
      ),


    },

    {
      title: 'Type',
      dataIndex: 'reg_type',
      key: 'reg_type',
      sorter: (a, b) => a.reg_type.localeCompare(b.reg_type),
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <span>{record.reg_type}</span>
        </Space>
      ),
    },
    {
      title: 'Profile',
      dataIndex: 'member_portal_profile_picture',
      key: 'member_portal_profile_picture',

      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {
            commonUtility.sanitizeObject(record.member_portal_profile_picture) != "" ? <>
              <Avatar src={`${MEMBER_MEDIA_URL}${record.member_portal_profile_picture}`} />
            </> : commonUtility.sanitizeObject(record.profile_picture) != "" ? <>
              <Avatar src={`${MEDIA_URL}${record.profile_picture}`} />
            </> : <>
              <Avatar icon={<UserOutlined />} />
            </>
          }

        </Space>
      ),

    },
    {
      title: 'Name',
      dataIndex: 'member_fname',
      key: 'member_fname',
      sorter: (a, b) => {
        const nameA = `${a.member_fname} ${a.member_lname}`;
        const nameB = `${b.member_fname} ${b.member_lname}`;
        return nameA.localeCompare(nameB);
      },
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <span>{record.member_fname} {record.member_lname}</span>
        </Space>
      ),

    },

    // {
    //   title: 'Last Name',
    //   dataIndex: 'member_lname',
    //   key: 'member_lname',

    // },

    {
      title: 'DOB',
      dataIndex: 'date_of_birth',
      key: 'date_of_birth',
    },

    {
      title: 'Gender',
      dataIndex: 'gender',
      key: 'gender',
      //sorter: (a, b) => a?.gender != null && b?.gender != null (a.gender.localeCompare(b?.gender)),
    },

    {
      title: 'Primary Mobile',
      dataIndex: 'primary_mobile',
      key: 'primary_mobile',
      sorter: (a, b) => a.primary_mobile - b.primary_mobile,
    },
    {
      title: 'Whatsapp no',
      dataIndex: 'whatsapp_no',
      key: 'whatsapp_no',
    },



    {
      title: 'Email',
      dataIndex: 'primary_email',
      key: 'primary_email',
      sorter: (a, b) => a.primary_email.localeCompare(b.primary_email),

    },

    {
      title: 'GSTIN',
      dataIndex: 'gstin_no',
      key: 'gstin_no',
      sorter: (a, b) => (a.gstin_no ?? '').localeCompare(b.gstin_no ?? ''),
    },

    {
      title: 'Add Line1',
      dataIndex: 'address_one',
      key: 'address_one',
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          <span>{record.address_one}</span>
        </Space>
      ),
    },

    {
      title: 'Add Line2',
      dataIndex: 'address_two',
      key: 'address_two',
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          <span>{record.address_two}</span>
        </Space>
      ),
    },

    {
      title: 'Father Name',
      dataIndex: 'father_name',
      key: 'father_name',
      sorter: (a, b) => (a.father_name ?? '').localeCompare(b.father_name ?? ''),
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <span>{record.father_name}</span>
        </Space>
      ),


    },
    {
      title: 'Father Mobile',
      dataIndex: 'father_mobile',
      key: 'father_mobile',
      sorter: (a, b) => (a.father_mobile ?? '').localeCompare(b.father_mobile ?? ''),
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <span>{record.father_mobile}</span>
        </Space>
      ),
    },

    {
      title: 'Father Occupation',
      dataIndex: 'father_occupation',
      key: 'father_occupation',
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <span>{record.father_occupation}</span>
        </Space>
      ),
    },

    {
      title: 'Father Company',
      dataIndex: 'father_company',
      key: 'father_company',
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <span>{record.father_company}</span>
        </Space>
      ),
    },

    {
      title: 'Mother Name',
      dataIndex: 'monther_name',
      key: 'monther_name',
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <span>{record.monther_name}</span>
        </Space>
      ),
    },
    {
      title: 'Mother Mobile',
      dataIndex: 'mother_mobile',
      key: 'mother_mobile',
      //sorter: (a, b) => (a.mother_mobile ?? '').localeCompare(b.mother_mobile ?? ''),
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <span>{record.mother_mobile}</span>
        </Space>
      ),
    },

    {
      title: 'Mother Occupation',
      dataIndex: 'mother_occupation',
      key: 'mother_occupation',
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          <span>{record.mother_occupation}</span>
        </Space>
      ),
    },
    {
      title: 'Mother Company',
      dataIndex: 'mother_company',
      key: 'mother_company',
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          <span>{record.mother_company}</span>
        </Space>
      ),
    },

    {
      title: 'School',
      dataIndex: 'school',
      key: 'school',
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          <span>{record.school}</span>
        </Space>
      ),
    },

    {
      title: 'Class',
      dataIndex: 'mem_class',
      key: 'mem_class',
    },

    {
      title: 'Weekly Holiday',
      dataIndex: 'weekly_holiday',
      key: 'weekly_holiday',
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          <span>{record.weekly_holiday}</span>
        </Space>
      ),
    },

    {
      title: 'School Timing',
      dataIndex: 'school_timing',
      key: 'school_timing',
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          <span>{record.school_timing}</span>
        </Space>
      ),
    },

    {
      title: 'Beginner',
      dataIndex: 'is_begineer',
      key: 'is_begineer',
    },

    {
      title: 'Playing For',
      dataIndex: 'playing_for',
      key: 'playing_for',
    },



    {
      title: 'Code',
      dataIndex: 'member_code',
      key: 'member_code',
      sorter: (a, b) => a.member_code.localeCompare(b.member_code),

    },


  ];




  useEffect(() => {
    console.log('isSuccessRefreshList', isSuccessRefreshList);
    memberService.allMemberListPersonalInfo().then((res) => {
      setMemberList(res.data.response_data)
      setFilteredSearchList(res.data.response_data);
    });
  }, [isSuccessRefreshList])

  const onSearch = (e) => {
    setFilteredSearchList([]);
    const string = e.target.value;
    const filtered_list = memberList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
    setFilteredSearchList(filtered_list)
  }


  const onFilterApply = (value) => {
    console.log("On Filter Apply", value);
  }

  const filterForm = (


    <>

      <div className="filterBoxContainer">

        <Form
          form={filterFormData}
          onFinish={onFilterApply}

        >
          <Row className="filterFormRow" style={{ marginTop: '0px' }}>
            <Col className="gutter-row" xs={24} xl={24}>
              <Form.Item name="reg_type" label="">
                <Select
                  className="text-left"
                  placeholder="Reg Type"
                  allowClear={true}
                >
                  <Option key="STUDENT" value="STUDENT">Student</Option>
                  <Option key="MEMBER" value="MEMBER">Member</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row className="filterFormRow">
            <Col className="gutter-row" xs={24} xl={24}>
              <Form.Item name="gender" label="">
                <Select
                  className="text-left"
                  placeholder="Gender"
                  allowClear={true}
                >
                  <Option key="M" value="M">Male</Option>
                  <Option key="F" value="F">Female</Option>
                  <Option key="O" value="O">Other</Option>
                </Select>

              </Form.Item>
            </Col>
          </Row>

          <Row className="filterFormRow">
            <Col className="gutter-row" xs={24} xl={24}>
              <Form.Item name="memberId" label="" >
                <Input type="text" placeholder="Mobile No" />
              </Form.Item>
            </Col>
          </Row>

          <Row className="filterFormRow">
            <Col className="gutter-row" xs={24} xl={24} align="center">
              <Button htmlType="submit" type="primary" shape="round"> Apply Filter </Button>
            </Col>
          </Row>
        </Form>

      </div>




    </>
  );

  const text = <span>Filter By</span>;


  return (
    <>

      <Row gutter={20} style={{ height: '45px', padding: '3px' }}>
        <Col xs={24} xl={24} align="right">

          {/* <Popover placement="bottomRight" title={text} content={filterForm} trigger="click">
                <Button type="primary" shape="round" style={{background:'#685211',border:'0'}}><FilterOutlined /> Filter</Button>
              </Popover> */}

          <div className="withFilterSearchBox">
            <CustomTableSearch onSearchTable={onSearch} />
          </div>

        </Col>
        {/* <Col  xs={24} xl={8} >
          <div className="withFilterSearchBox">
              <CustomTableSearch onSearchTable={onSearch}  />
          </div>
        </Col> */}
      </Row>

      <div>
        <Table
          columns={columns}
          rowKey='member_id'
          dataSource={filteredSearchList}
          pagination={{
            showTotal,
            onChange(current) {
              setPage(current);
            }
          }}
          size="small"
        // scroll={{
        //   x: 1500,
        //   y:350
        // }}
        // summary={() => (
        //   <Table.Summary fixed={true ? 'top' : 'bottom'}>

        //   </Table.Summary>
        // )}

        />
      </div>


    </>
  );
};

export default RegistrationList;